import { useParams } from "react-router-dom";
import TrialFindingsReport from "./TrialFindingsReport";

export default function TrialFindingsRoute() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-slate-900">
        <div className="text-sm text-slate-600">Missing slug.</div>
      </div>
    );
  }
  return <TrialFindingsReport slug={slug} />;
}
